import { helperFunctions } from 'utils/helperFunctions';
import { createKpiTileItem } from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { formatTimeWithSeconds } = helperFunctions();
    const { avgTimeInPlatform, avgTimeInPlatformDelta } =
      data?.getUserAdoptionScorecard?.data || {};

    return createKpiTileItem(
      'Average Time In Platform',
      formatTimeWithSeconds(avgTimeInPlatform),
      avgTimeInPlatformDelta
        ? {
            isPositiveValue: avgTimeInPlatformDelta >= 0,
            text: formatTimeWithSeconds(avgTimeInPlatformDelta),
            sideLabel: '',
            showArrow: Number(avgTimeInPlatformDelta) !== 0,
          }
        : null
    );
  },
};
